import { getFormatInstance } from '@sas-dvr/ltjs-sasicu/util/SASFormatterUtil';
export function formatValue(formatName, value) {
    if (!formatName) {
        return value.toString();
    }
    const formatter = getFormatInstance(formatName) || getFormatInstance('BEST6');
    return formatter.format(value) || '';
}
export function parseString(stringValue, locale) {
    return getFormatInstance('COMMA.', locale).parse(stringValue);
}
